import type { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { TableCellTooltip } from './TableTextCell';

export type TableIdentityCellProps = {
  primary: ReactNode;
  secondary?: ReactNode;
  leading?: ReactNode;
  trailing?: ReactNode;
  primaryTitle?: string;
  secondaryTitle?: string;
};

export function TableIdentityCell({ primary, secondary, leading, trailing, primaryTitle, secondaryTitle }: TableIdentityCellProps) {
  const hasSecondary = secondary !== undefined && secondary !== null && secondary !== '';
  const fullText = [primaryTitle ?? (typeof primary === 'string' ? primary : undefined), secondaryTitle ?? (typeof secondary === 'string' ? secondary : undefined)].filter(Boolean).join('\n');

  return <TableCellTooltip fullText={fullText}><Stack direction="row" spacing={1} sx={{ alignItems: 'center', minWidth: 0, width: '100%' }}>
    {leading != null && <Box sx={{ display: 'flex', flexShrink: 0 }}>{leading}</Box>}
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center', minWidth: 0 }}>
        <Typography component="div" data-table-text variant="body2" noWrap sx={{ minWidth: 0, fontWeight: 700 }}>{primary}</Typography>
        {trailing != null && <Box sx={{ display: 'flex', flexShrink: 0 }}>{trailing}</Box>}
      </Stack>
      {hasSecondary && <Typography component="div" data-table-text variant="caption" color="text.secondary" noWrap>{secondary}</Typography>}
    </Box>
  </Stack></TableCellTooltip>;
}
